import { memo } from 'react'

interface OnboardingBtnProps {
  text: string
  onClick: () => void
}

const OnboardingBtn: React.FC<OnboardingBtnProps> = memo(
  ({ text, onClick }) => {
    return (
      <button
        onClick={onClick}
        className="w-fit btn btn-secondary relative z-50 !rounded-full !border-0 before:content-[''] before:absolute before:inset-0 before:rounded-full before:p-[2px]
  before:bg-[linear-gradient(108deg,var(--Tertiary,#F6911D)_8.22%,var(--Secondary,#FF04FF)_44.27%,var(--Primary,#0FF)_80.31%)]
  before:-z-10
  before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]
  before:[-webkit-mask-composite:xor] before:[mask-composite:exclude]"
      >
        {text}
      </button>
    )
  },
)

export { OnboardingBtn }
